// extracted by mini-css-extract-plugin
module.exports = {"pill":"Pill_pill__2x8cT","clickable":"Pill_clickable__Q0W6h","text":"Pill_text__3V3y9","icon":"Pill_icon__L2eMh"};